import * as React from 'react';
const SvgAddToList = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width="1em" height="1em" viewBox="0 0 17 14" fill="none" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M1.125.003a1 1 0 100 2h14a1 1 0 100-2h-14zm-1 5a1 1 0 011-1h7a1 1 0 010 2h-7a1 1 0 01-1-1zm0 4a1 1 0 011-1h4a1 1 0 010 2h-4a1 1 0 01-1-1zm9 1a1 1 0 110-2h2v-2a1 1 0 012 0v2h2a1 1 0 110 2h-2v2a1 1 0 01-2 0v-2h-2z"
            fill="currentColor"
        />
    </svg>
);
export default SvgAddToList;
